<template>
  <div class="wf-w-full">
    <div v-show="isInput">
      <div v-show="withLabel" :contenteditable="! previewMode" :class="elementLabelClasses" :style="elementLabelStyles"  v-text="label" @input="label = $event.target.textContent"></div>
      <div class="wf-w-full wf-flex wf-p-2 wf-justify-between hover-trigger" :class="elementClasses" :style="elementStyles">
        <div v-show="withPlaceholder" @keydown.enter.prevent :contenteditable="! previewMode" class="focus:wf-outline-none" v-text="placeholder" @input="placeholder = $event.target.textContent"></div>
        <div class="wf-flex hover-target" v-show="! previewMode">
          <span class="wf-text-black wf-opacity-50 wf-text-sm">form {{content.type}}</span>
          <button @click.prevent="removeInput" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-trash"></i></button>
          <button @click.prevent="openInputModal" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-edit"></i></button>
        </div>
      </div>
    </div>
    <div v-show="isRadio" class="wf-flex wf-justify-between">
      <div>
        <div :contenteditable="! previewMode" :class="elementLabelClasses" :style="elementLabelStyles" @keydown.enter.prevent v-text="label" @input="label = $event.target.textContent"></div>  
        <ul>
          <li v-for="(option, index) in content.options" :key="index" class="wf-flex wf-my-4 wf-items-center">
            <input type="radio" @click.prevent :checked="index == 0">
            <div class="wf-ml-2 wf-text-sm wf-leading-none" v-text="option.text"></div>
          </li>
        </ul>
      </div>
      <div class="wf-flex hover-target">
          <span class="wf-text-black wf-opacity-50 wf-text-sm">form {{content.type}}</span>
          <button @click.prevent="removeInput" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-trash"></i></button>
          <button class="form-components-handle wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-arrows-alt"></i></button>
          <button @click.prevent="openInputModal" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-edit"></i></button>
        </div>
    </div>
    <div v-show="isCheckbox">
      <div class="wf-flex wf-items-center wf-justify-between">
        <div class="wf-flex wf-items-center">
          <input type="checkbox" checked @click.prevent>
          <div :contenteditable="! previewMode" class="wf-ml-2 wf-text-xs wf-font-semibold" @keydown.enter.prevent v-text="label" @input="label = $event.target.textContent"></div>  
        </div>
        
        <div class="wf-flex hover-target">
          <span class="wf-text-black wf-opacity-50 wf-text-sm">form {{content.type}}</span>
          <button @click.prevent="removeInput" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-trash"></i></button>
          <button class="form-components-handle wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-arrows-alt"></i></button>
          <button @click.prevent="openInputModal" class="wf-ml-2 wf-text-sm wf-text-black wf-opacity-25 focus:wf-outline-none"><i class="fas fa-edit"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {StylesParser} from '../StylesParser'
  import {ConstantsParser} from '../ConstantsParser'
  import ArrayManipulation from '../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    props: {
      parentModule: {
        type: String,
        required: false
      },
      withPlaceholder: {
        type: Boolean,
        required: false,
        default: false
      },
      withLabel: {
        type: Boolean,
        required: false,
        default: false
      },
      labelClasses: {
        type: [Object],
        required: true,
      },
      labelStyles: {
        type: [Object],
        required: true,
      },
      classes: {
        type: [Object],
        required: true,
      },
      styles: {
        type: [Object],
        required: true,
      },
    },
    computed: {
      previewMode() {
        return this.$store.state.previewMode
      },
      device() {
        return this.parent.device
      },
      isInput() {
        return ! this.isRadio && ! this.isCheckbox
      },
      isRadio() {
        return this.content.type == 'radio'
      },
      isCheckbox() {
        return this.content.type == 'checkbox'
      },
      id() {
        return this.$vnode.key
      },
      parent() {
        return this.$parent.$parent
      },
      formRowId() {
        return this.parent.parent.id
      },
      formColumnId() {
        return this.parent.id
      },
      formElement() {
        return this.parent.formElement
      },
      inputElement() {
        let formRowIndex = this.form.content.rows.findIndex(formRow => formRow.id == this.formRowId)
        let formColumnIndex = this.form.content.rows[formRowIndex].columns.findIndex(formColumn => formColumn.id == this.formColumnId)
        let formInputIndex = this.form.content.rows[formRowIndex].columns[formColumnIndex].components.findIndex(formComponent => formComponent.id == this.id)
        let inputElement= {
          formRow: formRowIndex,
          formColumn: formColumnIndex,
          formInput: formInputIndex,
        }
        return inputElement
      },
      elementLabelStyles() {
        return (new StylesParser(this.labelStyles, this.device)).parse()
      },
      elementStyles() {
        return (new StylesParser(this.styles, this.device)).parse()
      },
      typeClasses() {
        return {
          text: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          email: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          time: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          checkbox: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          number: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          date: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          select: {
            desktop: [],
            tablet: [],
            phone: [],
          },
          textarea: {
            desktop: [
              {property: 'Height', value: 'HEIGHT_XL', touched: false}
            ],
            tablet: [
              {property: 'Height', value: 'HEIGHT_XL', touched: false}
            ],
            phone: [
              {property: 'Height', value: 'HEIGHT_XL', touched: false}
            ],
          },
          radio: {
            desktop: [],
            tablet: [],
            phone: [],
          }
        }
      },
      elementLabelClasses() {
        return (new ConstantsParser(this.labelClasses, this.device)).parse()
      },
      elementClasses() {
        let classes = (new ConstantsParser(this.classes, this.device)).parse()
        let typeClasses = (new ConstantsParser(this.typeClasses[this.content.type], this.device)).parse()
        return [...classes, ...typeClasses]
      },
      form() {
        return this.$store.getters[`${this.module}/elements`](this.formElement, this.parentModule)
      },
      module() {
        return this.parent.module
      },
      formRows() {
        return this.form.content.rows
      },
      content() {
        return this.parent.components.find(formComponent => formComponent.id == this.id).content
      },
      label: {
        get() {
          return this.content.label
        },
        set: _.debounce(function (value) {
          let element = this.mapElement({...this.content, label: value})
          this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
        }, 1000)
      },
      placeholder: {
        get() {
          return this.content.placeholder
        },
        set: _.debounce(function (value) {
          let element = this.mapElement({...this.content, placeholder: value})
          this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
        }, 1000)
      }
    },
    methods: {
      openInputModal() {
        this.$modal.show('inputModal', {
          module: this.module,
          formElement: this.formElement,
          inputElement: this.inputElement,
          parentModule: this.parentModule
        })
      },
      removeInput() {
        let element = Array.from(this.formRows).map(formRow => {
          if (this.formRowId != formRow.id) {
            return formRow
          }
          let formColumns = formRow.columns.map(formColumn => {
            if (this.formColumnId != formColumn.id) {
              return formColumn
            }
            let formComponents = formColumn.components.filter(formComponent => formComponent.id != this.id)
            return {...formColumn, components: formComponents}
          })
          return {...formRow, columns: formColumns}
        })
        this.addToObject(this.module, {rows: element}, 'content', null, this.formElement, true, this.parentModule)
      },
      mapElement(newContent) {
        let newRows = Array.from(this.formRows).map(formRow => {
          if (this.formRowId != formRow.id) {
            return formRow
          }
          let formColumns = formRow.columns.map(formColumn => {
            if (this.formColumnId != formColumn.id) {
              return formColumn
            }
            let formComponents = formColumn.components.map(formComponent => {
              if (formComponent.id != this.id) {
                return formComponent
              }
              return {...formComponent, content: newContent}
            })
            return {...formColumn, components: formComponents}
          })
          return {...formRow, columns: formColumns}
        })
        return newRows
      }
    }
  }
</script>

<style lang="css">
  .hover-trigger .hover-target {
    display: none;
  }

  .hover-trigger:hover .hover-target {
    display: block;
  }
</style>